import { ReduxState } from 'src/store/types';
import {
  DEFAULT_MODEL,
  SPECIAL_NAMED_GRAPH_IRIS,
} from 'src/templates/queries/iris';

export const publishableDefaultModelNamedGraph =
  (databaseId: string) => (state: ReduxState) => {
    const db = state.databases.databasesById[databaseId];
    if (
      !db ||
      !db.namedGraphs ||
      !db.namedGraphsByModel ||
      !db.namedGraphsByModel[DEFAULT_MODEL]
    ) {
      return null;
    }
    const reasoningSchemaGraphs = db.namedGraphsByModel[DEFAULT_MODEL];
    // Allow when reasoning.schema.graphs is not set to a wildcard, special
    // named graph, alias, virtual graph, or multiple graphs

    // Note that wildcards are already converted to special IRIs when
    // db.namedGraphsByModel is created via getDefaultModelNamedGraphs
    if (reasoningSchemaGraphs.length !== 1) {
      return null;
    }
    const namedGraph = db.namedGraphs[reasoningSchemaGraphs[0]];
    if (
      !namedGraph ||
      namedGraph.isAlias ||
      namedGraph.isVirtual ||
      SPECIAL_NAMED_GRAPH_IRIS.includes(namedGraph.iri)
    ) {
      return null;
    }
    return namedGraph;
  };
